export enum ScheduleTypeEnum {
  AB = 'AB',
  WEEK = 'WEEK'
}

/**
 * Enum representing the working days in an AB schedule.
 * A and B are the full days, while AS and BS are the short for A and B days, respectively.
 */
export enum ABWorkingdays {
  A = 'A',   // Day A Full
  B = 'B',    // Day B Full
  AS = 'AS', // Day A Short
  BS = 'BS', // Day B Short
}

export enum ABWorkingdaysLabels {
  A = 'A',
  B = 'B',
  AS = 'ashortday',
  BS = 'bshortday',
}

/** 
 * Record to map a full A/B day to its short day 
 */
export const ABShortWorkingDays: Record<ABWorkingdays, ABWorkingdays | null> = {
  [ABWorkingdays.A]: ABWorkingdays.AS,
  [ABWorkingdays.B]: ABWorkingdays.BS,
  [ABWorkingdays.AS]: null,
  [ABWorkingdays.BS]: null,
};